module.exports = __webpack_public_path__ + "img/itZert_9001_rgb.85db4ea.png";